
<template>
	<div class="customview content" >
        <div class="row custom card">
            <div class="col-12">

                <div  v-html="resource.body"></div>
        
      
            </div>

        </div>

	</div>
</template>


<script>
import $ from "jquery";
import _ from "lodash";
import store from "@/services/Store";
import Utils from "@/services/Utils";
import ResourceService from "@/services/ResourceService";
import AssessmentService from "@/services/AssessmentService";

export default {
	name: "HTMLView",
	props: ["user"],
	data() {
        return {
            resource :null,
            assessment:null,
        }
	},

	created() {
        
	},

	mounted() {
        console.log()
        this.getAssessment()

	},


	methods: {
    getAssessment(){
    AssessmentService.getPublicAssessment(this.$route.params.assessmentID)
        .then(resp => {
                    console.log(resp.data);

          this.assessment = resp.data;
        if(this.assessment.public){
            this.LoadPublicData()
        } else {
            this.LoadData()
        }
        })
        .catch(err => {
          console.log(err);
        });
    },
    LoadData() {
      return ResourceService.HTMLResource(this.$route.params.assessmentID,this.$route.params.sequence)
        .then(resp => {
          console.log("got resource ",resp.data)
          this.resource = resp.data

        })
        .catch(err => {
          console.log(err);
        });
    },
        LoadPublicData() {
      return ResourceService.HTMLPublicResource(this.$route.params.assessmentID,this.$route.params.sequence)
        .then(resp => {
          console.log("got resource ",resp.data)
          this.resource = resp.data

        })
        .catch(err => {
          console.log(err);
        });
    },
    }
};
</script>

<style scoped>
img{
	max-width: 100%;
	max-height: 100%;
	display: block; /* remove extra space below image */
}

.customview{
    margin: 30px;
}
.inverted {
	background-color: black;
	color: white;
}
.label {
	position: relative;
	top: 10px;
	left: 15px;
}
.respText{
    overflow: auto
}
.custom{
    padding-top: 20px;
}
.card {
    border-radius: 0%;
}

</style>



// WEBPACK FOOTER //
// src/components/viewer/HTMLView.vue